// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.TWj4kD {
  display: flex;
  gap: 0;
  background: var(--card-background, #ffffff);
  border-radius: var(--radius-s, 4px);
  box-shadow: var(--card-box-shadow, 0px 2px 4px 0px rgba(0, 0, 0, 0.12));
  overflow: hidden;
  white-space: nowrap;
  height: 129px;

  .Byow35 {
    &:first-child {
      padding-left: var(--spacing-2, 16px);
      margin-right: auto;
    }

    &:last-child {
      padding-right: var(--spacing-2, 16px);
      margin-left: auto;
    }

    padding: 0 var(--spacing-3, 24px);

    &:has(+ .tMnw4I.LINl9g) {
      display: none;
    }
  }

  .tMnw4I.LINl9g + .Byow35 {
    display: none;
  }
}

.tMnw4I {
  display: flex;
  flex-direction: row;
  align-items: center;
  overflow: hidden;
  flex-grow: 1;

  :not(.LINl9g) {
    > *:first-child {
      padding-left: 0;
    }

    > *:last-child {
      padding-right: 0;
    }
  }
}

@keyframes aaklKT {
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}

.zYzr0r {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  flex: 0 0 auto;
  padding: var(--spacing-3, 24px);
  gap: var(--spacing-2, 16px);
  min-height: 88px;
  transition:
    background-color 0.2s ease,
    opacity 0.3s ease;
  cursor: pointer;
  opacity: 0;
  --animation-delay: 0s;

  &.MgLLgO {
    opacity: 1;
    animation: aaklKT 0.5s ease-out forwards;
    animation-delay: var(--animation-delay);
  }

  &:not(.MgLLgO) {
    transition: opacity 0.3s ease;
  }
}

.zYzr0r:hover {
  background-color: var(--surface-neutral-subtle, rgba(0, 0, 0, 0.02));
}

.zYzr0r:focus {
  outline: 2px solid var(--surface-primary-medium);
  outline-offset: -2px;
}

.XMJkYR {
  cursor: default;
}

.XMJkYR:hover {
  background-color: transparent;
}

.p2eVrQ {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: var(--spacing-1-5, 12px);
  width: 100%;
}

.ys8slU {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 32px;
  height: 32px;
  background: var(--surface-warning-subtle, #d64000);
  border-radius: var(--radius-xl, 16px);
  flex-shrink: 0;
}

.URtBlm {
  width: 16px;
  height: 16px;
  color: var(--surface-neutral-inverted, #ffffff);
}

.J3DxMN {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-0-25, 2px);
  flex: 1;
}

.Pxeo5f {
  font-family: var(--font-family-base, 'Source Sans 3');
  font-weight: var(--font-weight-regular, 400);
  font-size: var(--type-body-md-font-size, 16px);
  line-height: var(--type-body-md-line-height, 1.424);
  color: var(--text-primary, #1f1f1f);
  margin: 0;
}

.fDV4sk {
  display: flex;
  align-items: center;
  gap: var(--spacing-1, 8px);
}

.H7KJXu {
  font-family: var(--font-family-base, 'Source Sans 3');
  font-weight: var(--font-weight-regular, 200);
  font-size: var(--type-label-sm-font-size, 12px);
  line-height: var(--type-label-sm-line-height, 2);
  color: var(--text-secondary, #cccccc);
}

.S_lFSk {
  display: flex;
  align-items: center;
  gap: var(--spacing-0-5, 8px);
}

.u5ykMp {
  width: 6px;
  height: 6px;
  border-radius: 3px;
  flex-shrink: 0;
}

.bEreDd {
  background-color: var(--surface-neutral-muted, #cccccc);
}

.DCVNOd {
  background-color: var(--surface-success-subtle, #28a745);
}

.yiWIym {
  font-family: var(--font-family-base, 'Source Sans 3');
  font-weight: var(--type-label-xs-font-weight, 400);
  font-size: var(--type-label-xs-font-size, 12px);
  line-height: var(--type-label-xs-line-height, 1.424);
  color: var(--surface-neutral-muted, #cccccc);
}

.xkwLoS {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
}

.yk7x5j {
  font-family: var(--font-family-base, 'Source Sans 3');
  font-weight: var(--font-weight-semibold, 600);
  font-size: var(--type-body-md-font-size, 16px);
  line-height: var(--type-body-md-line-height, 1.424);
  color: var(--text-primary, #1f1f1f);
}

.XMJkYR .yk7x5j {
  font-weight: var(--type-body-sm-font-weight, 400);
  font-size: var(--type-body-sm-font-size, 14px);
  line-height: var(--type-body-sm-line-height, 1.8);
}

.QDE8se {
  flex-shrink: 0;
}

.qENaMu {
  width: 1px;
  height: 88px;
  background-color: var(--border-subtle, #f2f2f2);
  flex-shrink: 0;
}

/* Responsive adjustments */
@media (max-width: 768px) {
  .TWj4kD {
    flex-direction: column;
  }

  .qENaMu {
    width: 100%;
    height: 1px;
  }

  .zYzr0r {
    min-width: 100%;
  }
}
`, "",{"version":3,"sources":["webpack://./../../packages/shared-ui/src/components/DomainCards/DomainCards.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,MAAM;EACN,2CAA2C;EAC3C,mCAAmC;EACnC,uEAAuE;EACvE,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;;EAEb;IACE;MACE,oCAAoC;MACpC,kBAAkB;IACpB;;IAEA;MACE,qCAAqC;MACrC,iBAAiB;IACnB;;IAEA,iCAAiC;;IAEjC;MACE,aAAa;IACf;EACF;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,YAAY;;EAEZ;IACE;MACE,eAAe;IACjB;;IAEA;MACE,gBAAgB;IAClB;EACF;AACF;;AAEA;EACE;IACE,UAAU;EACZ;;EAEA;IACE,UAAU;EACZ;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,cAAc;EACd,+BAA+B;EAC/B,2BAA2B;EAC3B,gBAAgB;EAChB;;qBAEmB;EACnB,eAAe;EACf,UAAU;EACV,qBAAqB;;EAErB;IACE,UAAU;IACV,wCAA4C;IAC5C,uCAAuC;EACzC;;EAEA;IACE,6BAA6B;EAC/B;AACF;;AAEA;EACE,oEAAoE;AACtE;;AAEA;EACE,gDAAgD;EAChD,oBAAoB;AACtB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,6BAA6B;EAC7B,WAAW;AACb;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,kDAAkD;EAClD,qCAAqC;EACrC,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,+CAA+C;AACjD;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,6BAA6B;EAC7B,OAAO;AACT;;AAEA;EACE,qDAAqD;EACrD,4CAA4C;EAC5C,8CAA8C;EAC9C,mDAAmD;EACnD,mCAAmC;EACnC,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;EACE,qDAAqD;EACrD,4CAA4C;EAC5C,+CAA+C;EAC/C,gDAAgD;EAChD,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,4BAA4B;AAC9B;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,uDAAuD;AACzD;;AAEA;EACE,wDAAwD;AAC1D;;AAEA;EACE,qDAAqD;EACrD,kDAAkD;EAClD,+CAA+C;EAC/C,oDAAoD;EACpD,4CAA4C;AAC9C;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,qDAAqD;EACrD,6CAA6C;EAC7C,8CAA8C;EAC9C,mDAAmD;EACnD,mCAAmC;AACrC;;AAEA;EACE,iDAAiD;EACjD,8CAA8C;EAC9C,iDAAiD;AACnD;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,+CAA+C;EAC/C,cAAc;AAChB;;AAEA,2BAA2B;AAC3B;EACE;IACE,sBAAsB;EACxB;;EAEA;IACE,WAAW;IACX,WAAW;EACb;;EAEA;IACE,eAAe;EACjB;AACF","sourcesContent":[".container {\n  display: flex;\n  gap: 0;\n  background: var(--card-background, #ffffff);\n  border-radius: var(--radius-s, 4px);\n  box-shadow: var(--card-box-shadow, 0px 2px 4px 0px rgba(0, 0, 0, 0.12));\n  overflow: hidden;\n  white-space: nowrap;\n  height: 129px;\n\n  .sliderControls {\n    &:first-child {\n      padding-left: var(--spacing-2, 16px);\n      margin-right: auto;\n    }\n\n    &:last-child {\n      padding-right: var(--spacing-2, 16px);\n      margin-left: auto;\n    }\n\n    padding: 0 var(--spacing-3, 24px);\n\n    &:has(+ .slider.sliderDisabled) {\n      display: none;\n    }\n  }\n\n  .slider.sliderDisabled + .sliderControls {\n    display: none;\n  }\n}\n\n.slider {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  overflow: hidden;\n  flex-grow: 1;\n\n  :not(.sliderDisabled) {\n    > *:first-child {\n      padding-left: 0;\n    }\n\n    > *:last-child {\n      padding-right: 0;\n    }\n  }\n}\n\n@keyframes cardFadeIn {\n  from {\n    opacity: 0;\n  }\n\n  to {\n    opacity: 1;\n  }\n}\n\n.card {\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  flex: 0 0 auto;\n  padding: var(--spacing-3, 24px);\n  gap: var(--spacing-2, 16px);\n  min-height: 88px;\n  transition:\n    background-color 0.2s ease,\n    opacity 0.3s ease;\n  cursor: pointer;\n  opacity: 0;\n  --animation-delay: 0s;\n\n  &.visible {\n    opacity: 1;\n    animation: cardFadeIn 0.5s ease-out forwards;\n    animation-delay: var(--animation-delay);\n  }\n\n  &:not(.visible) {\n    transition: opacity 0.3s ease;\n  }\n}\n\n.card:hover {\n  background-color: var(--surface-neutral-subtle, rgba(0, 0, 0, 0.02));\n}\n\n.card:focus {\n  outline: 2px solid var(--surface-primary-medium);\n  outline-offset: -2px;\n}\n\n.cardInactive {\n  cursor: default;\n}\n\n.cardInactive:hover {\n  background-color: transparent;\n}\n\n.cardHeader {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  gap: var(--spacing-1-5, 12px);\n  width: 100%;\n}\n\n.iconContainer {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 32px;\n  height: 32px;\n  background: var(--surface-warning-subtle, #d64000);\n  border-radius: var(--radius-xl, 16px);\n  flex-shrink: 0;\n}\n\n.icon {\n  width: 16px;\n  height: 16px;\n  color: var(--surface-neutral-inverted, #ffffff);\n}\n\n.titleContainer {\n  display: flex;\n  flex-direction: column;\n  gap: var(--spacing-0-25, 2px);\n  flex: 1;\n}\n\n.title {\n  font-family: var(--font-family-base, 'Source Sans 3');\n  font-weight: var(--font-weight-regular, 400);\n  font-size: var(--type-body-md-font-size, 16px);\n  line-height: var(--type-body-md-line-height, 1.424);\n  color: var(--text-primary, #1f1f1f);\n  margin: 0;\n}\n\n.subtitleContainer {\n  display: flex;\n  align-items: center;\n  gap: var(--spacing-1, 8px);\n}\n\n.subtitle {\n  font-family: var(--font-family-base, 'Source Sans 3');\n  font-weight: var(--font-weight-regular, 200);\n  font-size: var(--type-label-sm-font-size, 12px);\n  line-height: var(--type-label-sm-line-height, 2);\n  color: var(--text-secondary, #cccccc);\n}\n\n.subtitleWithStatus {\n  display: flex;\n  align-items: center;\n  gap: var(--spacing-0-5, 8px);\n}\n\n.statusBadge {\n  width: 6px;\n  height: 6px;\n  border-radius: 3px;\n  flex-shrink: 0;\n}\n\n.statusBadgeInactive {\n  background-color: var(--surface-neutral-muted, #cccccc);\n}\n\n.statusBadgeActive {\n  background-color: var(--surface-success-subtle, #28a745);\n}\n\n.statusText {\n  font-family: var(--font-family-base, 'Source Sans 3');\n  font-weight: var(--type-label-xs-font-weight, 400);\n  font-size: var(--type-label-xs-font-size, 12px);\n  line-height: var(--type-label-xs-line-height, 1.424);\n  color: var(--surface-neutral-muted, #cccccc);\n}\n\n.cardFooter {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  width: 100%;\n}\n\n.value {\n  font-family: var(--font-family-base, 'Source Sans 3');\n  font-weight: var(--font-weight-semibold, 600);\n  font-size: var(--type-body-md-font-size, 16px);\n  line-height: var(--type-body-md-line-height, 1.424);\n  color: var(--text-primary, #1f1f1f);\n}\n\n.cardInactive .value {\n  font-weight: var(--type-body-sm-font-weight, 400);\n  font-size: var(--type-body-sm-font-size, 14px);\n  line-height: var(--type-body-sm-line-height, 1.8);\n}\n\n.progressIndicator {\n  flex-shrink: 0;\n}\n\n.divider {\n  width: 1px;\n  height: 88px;\n  background-color: var(--border-subtle, #f2f2f2);\n  flex-shrink: 0;\n}\n\n/* Responsive adjustments */\n@media (max-width: 768px) {\n  .container {\n    flex-direction: column;\n  }\n\n  .divider {\n    width: 100%;\n    height: 1px;\n  }\n\n  .card {\n    min-width: 100%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `TWj4kD`,
	"sliderControls": `Byow35`,
	"slider": `tMnw4I`,
	"sliderDisabled": `LINl9g`,
	"card": `zYzr0r`,
	"cardFadeIn": `aaklKT`,
	"visible": `MgLLgO`,
	"cardInactive": `XMJkYR`,
	"cardHeader": `p2eVrQ`,
	"iconContainer": `ys8slU`,
	"icon": `URtBlm`,
	"titleContainer": `J3DxMN`,
	"title": `Pxeo5f`,
	"subtitleContainer": `fDV4sk`,
	"subtitle": `H7KJXu`,
	"subtitleWithStatus": `S_lFSk`,
	"statusBadge": `u5ykMp`,
	"statusBadgeInactive": `bEreDd`,
	"statusBadgeActive": `DCVNOd`,
	"statusText": `yiWIym`,
	"cardFooter": `xkwLoS`,
	"value": `yk7x5j`,
	"progressIndicator": `QDE8se`,
	"divider": `qENaMu`
};
module.exports = ___CSS_LOADER_EXPORT___;
